// MUI
import { Divider, Stack, Typography } from '@mui/material';

import { RepeatTaskSwitch as CustomSwitch } from 'components/AllDialogs/tasks/createTask/createTask.style';

// Styled
import { Content, SectionHeader, SectionHeaderText } from './styled';

import {
  RightPanel,
  RightHeader,
  RightHeaderTextBox,
  RightHeaderTextBold,
  RightHeaderTextNormal,
  PanelContentWrapper,
} from '../commonPanelStyled';

// Types
import { TemplateType } from 'pages/TemplateDashboard/context';

// Hooks
import usePatchTemplate from 'components/TemplateDashboard/TemplateSettingsModal/hooks/usePatchTemplate';

// Constants
import TemplateAndSubmissionAccess from 'components/TemplateAndSubmissionAccess';
import {
  SUBMISSION_ACCESS,
  TEMPLATE_ACCESS,
} from 'components/TemplateAndSubmissionAccess/utils';

interface AccessPropTypes {
  template: TemplateType;
  updateTemplateCb: (template: TemplateType) => void;
}

const Access = ({ template, updateTemplateCb }: AccessPropTypes) => {
  const {
    templateAccess,
    submissionAccess,
    togglePrivateOnMobile,
    updateTemplateAndSubmissionAccess,
  } = usePatchTemplate({ updateTemplateCb });

  const updateHandlerAdmins = (key, data) => {
    updateTemplateAndSubmissionAccess(key, data);
  };

  return (
    <RightPanel>
      <RightHeader>
        <RightHeaderTextBox>
          <RightHeaderTextBold>Template Access</RightHeaderTextBold>
          <RightHeaderTextNormal>
            Control access & privileges for this template
          </RightHeaderTextNormal>
        </RightHeaderTextBox>
      </RightHeader>
      <PanelContentWrapper>
        <Content>
          <TemplateAndSubmissionAccess
            type={TEMPLATE_ACCESS}
            data={templateAccess}
            onUpdate={(key, data) => updateHandlerAdmins(key, data)}
          />
          <TemplateAndSubmissionAccess
            type={SUBMISSION_ACCESS}
            data={submissionAccess}
            onUpdate={(key, data) => updateHandlerAdmins(key, data)}
          />
          <Divider />
          <Stack direction="column">
            <SectionHeader>
              <SectionHeaderText variant="h3">
                Privacy Controls
              </SectionHeaderText>
            </SectionHeader>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              marginTop="8px"
            >
              <CustomSwitch
                defaultChecked={template?.HotelChecklist?.isPrivateOnMobile}
                onChange={(e) => togglePrivateOnMobile(e.target.checked)}
              />
              <Stack>
                <Typography
                  fontSize="14px"
                  fontWeight={600}
                  color="rgba(33, 33, 33, 1)"
                >
                  Private on Mobile
                </Typography>
                <Typography
                  fontSize="13px"
                  color="rgba(66, 66, 66, 1)"
                  fontWeight={600}
                >
                  Hide all submissions for this template on the mobile app only.
                  Submissions will still be visible on the web app.
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Content>
      </PanelContentWrapper>
    </RightPanel>
  );
};

export default Access;
